import { defineMessages } from 'react-intl';
import { ExceededLoginAttempts, WorkstationLoginNotAuthorized, EmailNotYetVerified } from '../code-constants';

export const messages = defineMessages({
  [ExceededLoginAttempts]: {
    description: 'Login error message when too many login attempts have failed',
    defaultMessage:
      'This user account has been locked due to too many failed login attempts. Please try again in 30 minutes. Your administrator may also unlock your account by going to Settings > Manage Users.',
    id: 'pxeCje',
  },
  [WorkstationLoginNotAuthorized]: {
    description: 'Login error message when user is not authorized to login on this computer/workstation',
    defaultMessage:
      'Your user account has not been authorized to login to this workstation. An administrator must login from this browser, on this computer, and approve access for your account.',
    id: 'xKFJj9',
  },
  [EmailNotYetVerified]: {
    description: 'Login error message when user has not verified their email',
    defaultMessage: 'Your email address has not yet been verified. Please check your email for the verification link.',
    id: 'i+83Dx',
  },
});

export const loginErrors = ({ code }) => {
  return messages[code];
};
